import { Box, Typography } from '@mui/material';
import theme from '@shared/themes/darkTheme';

export const UpgradeBanner = () => {
  return (
    <Box
      sx={{
        backgroundColor: theme.palette.primary.main,
        padding: 2,
        borderRadius: 2,
        mb: 2,
        textAlign: 'center',
        width: 'fit-content',
        alignSelf: 'center',
      }}
    >
      <Typography>
        You are currently on a free tier.{' '}
        <a
          style={{ color: theme.palette.text.dark, textDecoration: 'underline' }}
          href="https://onyxcapitalgroup.typeform.com/onyx-flux?typeform-source=www.onyxcapitalgroup.com#source=ocg"
          target="_blank"
        >
          Upgrade to premium
        </a>{' '}
        to access all features.
      </Typography>
    </Box>
  );
};
